import * as ActionTypes from '../actions/constants';

const initialState = {
  product: {},
  filters: {
    type: 'PRINT_MEDIA',
  },
  isAdminView: false,
};

const cardDetail = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.RENDER_DETAIL:
      return { ...state, product: action.payload };
    case ActionTypes.DETAIL_ADMIN_VIEW:
      return { ...state, isAdminView: action.payload.isAdminView };
    default:
      return state;
  }
};

export default cardDetail;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/cardDetail.js
 **/